import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { find } from 'lodash';

import { useStores } from '@/hooks/use-stores';
import { DefaultBehaviour } from '@/store/Engine/constants';
import ValidationTooltip from '@/comp/pages/EnginePage/Engine/Common/ValidationTooltip/ValidationTooltip';
import { EPButton, EPSelect, EPSelectOption } from '@/components';

import { Radio } from '../Common/styled';

const FallbackRuleRadioGroup = observer(({ scenario, onScenarioFieldChange, onRulesGeneratorClick }) => {
  const { engineStore } = useStores();
  const { t } = useTranslation();

  return scenario?.fallbackRules?.map((fallbackRule, i) => (
    <div key={fallbackRule?.flowRangeKey ?? i}>
      {fallbackRule?.flowRangeName ? <div className="flow-range-name">{fallbackRule?.flowRangeName}</div> : null}
      <div className="rule-container">
        <ValidationTooltip
          message={
            find(engineStore?.validationMessages, {
              key: scenario?.id,
              field: 'fallbackRules',
              focused: true,
            })?.message
          }
        >
          <Radio.Group
            value={fallbackRule?.defaultBehaviour}
            className="rule-radio-group"
            onChange={onScenarioFieldChange(scenario?.id, 'defaultBehaviour', fallbackRule?.flowRangeKey)}
          >
            <Radio value={DefaultBehaviour.ExistingRule}>{t('chooseRule')}</Radio>
            <EPSelect
              value={fallbackRule?.ruleParentKey}
              disabled={fallbackRule?.defaultBehaviour !== DefaultBehaviour.ExistingRule}
              onChange={onScenarioFieldChange(scenario?.id, 'ruleParentKey', fallbackRule?.flowRangeKey)}
              size="small"
            >
              {engineStore.setpointsConfiguration?.getUniqueRangeSetpoints()?.map(setpoint => (
                <EPSelectOption key={setpoint?.parentRangeKey} value={setpoint?.parentRangeKey}>
                  {setpoint?.name}
                </EPSelectOption>
              ))}
            </EPSelect>
            <Radio value={DefaultBehaviour.CustomRule}>{t('customRule')}</Radio>
            <EPButton
              size="medium"
              type="primary"
              className="rule-generator-button"
              disabled={fallbackRule?.defaultBehaviour !== DefaultBehaviour.CustomRule}
              onClick={onRulesGeneratorClick(fallbackRule, scenario)}
            >
              <span className="button-label">{fallbackRule?.rules?.[0]?.name || t('ruleGenerator')}</span>
            </EPButton>
          </Radio.Group>
        </ValidationTooltip>
      </div>
    </div>
  ));
});

export default FallbackRuleRadioGroup;
